(function () {
  if (window.customElements.get('nathra-eta')) return;
  function isBiz(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6; }
  function addBiz(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isBiz(x)) n--; } return x; }
  function fmt(d, l) { return d.toLocaleDateString(l, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }); }
  class NathraEta extends HTMLElement {
    connectedCallback() {
      var out = this.querySelector('[data-eta-text]');
      if (!out) return;
      try {
        var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Dubai', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
        var g = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? parseInt(p.value, 10) : 0; };
        var today = new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
        var early = isBiz(today) && g('hour') < 12;
        var ship = early ? today : addBiz(today, 1);
        var a = addBiz(ship, 1), b = addBiz(ship, 3);
        var full = this.hasAttribute('data-full');
        if ((document.documentElement.lang || '').slice(0, 2) === 'ar') {
          out.innerHTML = 'يصلك <strong>' + fmt(a, 'ar-AE') + ' – ' + fmt(b, 'ar-AE') + '</strong> · توصيل مجاني' + (full ? ' · الدفع عند الاستلام · إرجاع خلال 14 يومًا' : '');
        } else {
          out.innerHTML = 'Arrives <strong>' + fmt(a, 'en-GB') + ' – ' + fmt(b, 'en-GB') + '</strong> · Free UAE delivery' + (full ? ' · Cash on delivery · 14-day returns' : '');
        }
      } catch (e) {}
    }
  }
  window.customElements.define('nathra-eta', NathraEta);
})();
